export enum ButtonBarColor {
  Primary = `primary`,
  Secondary = `secondary`,
  Blue = `blue`,
  Grey = `grey`,
  Purple = `purple`,
}
